import React from "react";
import "../tutorRegistration/TutorRegistration.css";

const AnalysisSection3 = () => {
  return (
    <div className="analysis-section">
      <div className="analysis-container">
        <div className="chart-overlap">
            
          <div className="analysis-card area-card">
            <div className="chart-title">Track Search Visibility!</div>
            <div className="chart-container">
              <div className="chart-axis-x">
                <div className="chart-axis-label">500</div>
                <div className="chart-axis-label">400</div>
                <div className="chart-axis-label">300</div>
                <div className="chart-axis-label">200</div>
                <div className="chart-axis-label">100</div>
                <div className="chart-axis-label">0</div>
              </div>
              <img
                src="/images/data2.png"
                alt="X-Y Analysis Chart"
                className="chart-image"
              />
              <div className="chart-axis-y">
                <div className="chart-axis-label">Jan</div>
                <div className="chart-axis-label">Feb</div>
                <div className="chart-axis-label">Mar</div>
                <div className="chart-axis-label">Apr</div>
                <div className="chart-axis-label">May</div>
                <div className="chart-axis-label">Jun</div>
                <div className="chart-axis-label">Jul</div>
                <div className="chart-axis-label">Aug</div>
                <div className="chart-axis-label">Sep</div>
                <div className="chart-axis-label">Oct</div>
                <div className="chart-axis-label">Nov</div>
                <div className="chart-axis-label">Dec</div>
              </div>
            </div>
          </div>
          <div className="analysis-card pie-card">
            <div className="chart-title">
              Keep Track of your visibility ratio to WhatsApp click.
            </div>
            <img
              src="/images/data1.png"
              alt="Pie Chart Analysis"
              className="pie-image"
            />
            <div className="analysis-icons">
              <div className="icon-container">
                <img
                  src="/images/visibility.png"
                  alt="visibility"
                  className="visibility"
                />
                <span className="icon-text">Visibility</span>
              </div>
              <div className="icon-container">
                <img
                  src="/images/whatsapp-link.png"
                  alt="whatsapp link"
                  className="whatsapp-link"
                />
                <span className="icon-text">WhatsApp Link</span>
              </div>
            </div>
          </div>
        </div>
        <div className="analysis-text">
          <img
            src="/images/tutorLogo.png"
            alt="Website Logo"
            className="tutor-logo"
          />
          <h2>Flexible Scheduling.</h2>
          <p>
            Enjoy the flexibility to choose when and how you want to tutor. Our
            platform allows you to set your schedule, ensuring that you can
            balance your teaching commitments with other aspects of your life
            while still earning rewards for your expertise.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisSection3;
